import Axios from 'axios'

const ENDPOINT = 'idea'

/**
 * Get
 */
export const getObj = (_id) => {
    return new Promise((resolve, reject) => {
        Axios.get(`/${ENDPOINT}/${_id}`)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

/**
 * Put
 * @param {*} obj
 */
export const putObj = (obj) => {
    return new Promise((resolve, reject) => {
        Axios.put(`/${ENDPOINT}`, obj)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

/**
 * Patch
 * @param {*} _id
 * @param {*} obj
 */
export const patchObj = (_id, obj) => {
    delete obj._id
    return new Promise((resolve, reject) => {
        Axios.patch(`/${ENDPOINT}/${_id}`, obj)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

/**
 * Delete
 * @param {*} _id
 */
export const deleteObj = (_id) => {
    return new Promise((resolve, reject) => {
        Axios.delete(`/${ENDPOINT}/${_id}`)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

// /**
//  * List TODO
//  */
export const listObj = (
    size,
    skip,
    sort,
    asc,
    search,
    filter_by,
    filter_value
) => {
    const params = {}
    if (size) params['size'] = size
    if (skip) params['skip'] = skip
    if (sort) params['sort'] = sort
    if (asc) params['asc'] = asc
    if (search) params['search'] = search
    if (filter_by) params['filter_by'] = filter_by
    if (filter_value) params['filter_value'] = filter_value

    return new Promise((resolve, reject) => {
        Axios.get(`/${ENDPOINT}`, {
            params: params,
        })
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}
